import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana112Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1422_16826)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M460.788 527.71L501.597 566.887L545.672 521.181L501.597 482.004L460.788 527.71Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M725.229 775.831L663.199 671.359L628.919 697.477C659.39 727.948 721.311 789.217 725.229 790.523C729.147 791.829 726.861 781.273 725.229 775.831Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M625.658 614.223L663.202 671.356L628.923 697.474L581.584 646.87L625.658 614.223Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M539.13 606.064L581.572 646.874L625.646 614.226L586.469 561.99L539.13 606.064Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M501.588 566.884L539.133 606.061L586.472 561.987L545.662 521.178L501.588 566.884Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M418.33 496.696L460.772 527.711L501.582 482.004L457.507 447.725L418.33 496.696Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M377.532 467.31L418.342 496.693L457.519 447.721L411.812 413.441L377.532 467.31Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M333.461 434.666L377.535 467.314L411.815 413.445L364.476 384.062L333.461 434.666Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M300.811 400.383C304.728 408.218 324.208 426.501 333.458 434.663L364.473 384.059L303.509 350.368C302.825 349.991 302.005 349.882 301.274 350.157C284.998 356.281 296.024 390.809 300.811 400.383Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1422_16826" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1422_16826" transform="matrix(0.00223907 0 0 0.00296841 -5.27911 -3.55028)"/>
    </pattern>
    <image id="image0_1422_16826"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};